import React from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';

type TabProps = {
    key: string;
    title: string;
    component: React.ReactNode;
}

type TabsProps = {
    tabs: TabProps[];
    variant: 'enclosed' | 'line' | 'enclosed-colored' | 'soft-rounded' | 'solid-rounded';
    size: 'sm' | 'md' | 'lg'
}

export default function CustomTabs({ tabs, ...props }: TabsProps) {
    return (
        <Tabs variant={props.variant} size={props.size}>
            {tabs.length && (
                <>
                    <TabList>
                       {tabs.map((tab) => (
                            <Tab key={tab.key}>{tab.title}</Tab>
                        ))}
                    </TabList>

                    <TabPanels>
                        {tabs.map((tab) => (
                            <TabPanel>
                               {tab.component}
                            </TabPanel>
                        ))}
                    </TabPanels>
                </>
            )}
        </Tabs>
    )
}
